// extracted by mini-css-extract-plugin
export default {"main":"Page_main__BRG76","inner":"Page_inner__TLnyb","h2":"Page_h2__1ak5e"};